import {
  ApplianceIcon,
  FurnitureIcon,
  InstallationIcon,
  MattressIcon,
  SofaIcon,
} from './CategoryIcons';
import './SingleItemRemoval.css';

const ITEMS = [
  { label: 'White Goods', href: '#white-goods', Icon: ApplianceIcon },
  { label: 'Radiators', href: '#radiators', Icon: InstallationIcon },
  { label: 'Metal Furniture', href: '#metal-furniture', Icon: FurnitureIcon },
  { label: 'Bike Frames', href: '#bike-frames', Icon: SofaIcon },
  { label: 'Machine Parts', href: '#machine-parts', Icon: MattressIcon },
];

export default function SingleItemRemoval() {
  return (
    <section className="single-item-removal" aria-labelledby="single-item-heading">
      <div className="single-item-inner">
        <h2 id="single-item-heading">Single Scrap Items</h2>

        <ul className="single-item-grid">
          {ITEMS.map(({ label, href, Icon }) => (
            <li key={label}>
              <a className="single-item-link" href={href}>
                <span className="single-item-art">
                  <Icon />
                </span>
                <span className="single-item-label">
                  {label} <span aria-hidden="true">→</span>
                </span>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
